import React, { useContext, useState } from "react";
import { useLoaderData } from "react-router-dom";
import { CartContext } from "../../layout/Main";
import Product from "../Product/Product";

const Catalogue = () => {
    const [cart ,setCart] = useContext(CartContext);
	const catalogue = useLoaderData();
    const handleAddToCart = (product) =>{
        const newCart = [...cart , product];
            setCart(newCart);
        
    }
    console.log(cart)
	return (
		<section className="catalogue mb-10">
			<div className="container mx-auto">
				<h2 className="text-4xl">
					Catalogue Items Found :
					<span className="text-5xl text-accent"> {catalogue.length}</span>
				</h2>
				<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 my-10">
                    {
                        catalogue.map( product => <Product                        
                        key={product.uniq_id}
                        product = {product}
                        handleAddToCart = {handleAddToCart}
                        >

                        </Product>)
                    }
				</div>
			</div>
		</section>
	);
};

export default Catalogue;
